"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkPriceAdjustmentPermission = void 0;
var _coamPermissions = require("../apis/coamPermissions");
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getPrincipal = function getPrincipal(decodedJWT) {
  return decodedJWT['https://claims.cimpress.io/email'];
};
var checkPriceAdjustmentPermission = function checkPriceAdjustmentPermission(accessToken, globalFulfillerId, merchantId) {
  var decodedJWT = (0, _jwtDecode["default"])(accessToken);
  var principal = getPrincipal(decodedJWT);
  var promises = [(0, _coamPermissions.checkPermission)(principal, 'merchants', merchantId, 'update:price-adjustment', accessToken), (0, _coamPermissions.checkPermission)(principal, 'fulfillers', globalFulfillerId, 'update:price-adjustment', accessToken)];
  return Promise.all(promises).then(function (response) {
    return response[0] && response[1];
  })["catch"](function () {
    return false;
  });
};
exports.checkPriceAdjustmentPermission = checkPriceAdjustmentPermission;